import { Flex, Image, Text, useDisclosure } from '@chakra-ui/react'
import { Button as UbiButton } from '@ubirider/pick-component-library'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'
import { useEffect, useState } from 'react'
import LandingBackground from '../../assets/mastercard_landing_bg.png'
import PickLogo from '../../assets/pick_logo.svg'

export default function Landing() {
  const { t } = useTranslation()

  const [login, getLogin] = useState(false)

  const { onOpen, isOpen, onClose } = useDisclosure()

  useEffect(() => {
    onOpen()
  }, [])

  return (
    <Flex
      as='main'
      direction='column'
      flex='1'
      minHeight='100vh'
      backgroundImage={`url(${LandingBackground})`}
      backgroundRepeat='no-repeat'
      backgroundSize='cover'
      backgroundPosition='center'
    >
      <Flex
        flex='1'
        height='100%'
        backgroundColor='rgba(86, 20, 229, 0.75)'
        padding={{ sm: '48px', md: '48px', lg: '80px' }}
        gap={{ sm: '56px', md: '56px', lg: '80px', xl: '80px' }}
      >
        <Flex
          direction='column'
          flex={{ sm: '1', md: '1', lg: '5', xl: '6' }}
          display={login ? { sm: 'none', md: 'none', lg: 'flex', xl: 'flex' } : 'flex'}
          justify='flex-start'
          align='flex-start'
        >
          <Flex direction='column' gap='60px' pt='48px'>
            <Flex gap='16px'>
              <Image src={PickLogo} w='98px' />
              <Text fontSize='16px' maxWidth='96px' lineHeight='16px' color='white'>
                {t('demo.my_mobility_account')}
              </Text>
            </Flex>

            <Text fontSize={{ sm: '36px', md: '36px', lg: '48px', xl: '48px' }} w='517px' fontWeight='700' color='white'>
              {t('demo.mobility_account_landing')}
            </Text>
          </Flex>

          <Flex alignSelf='stretch' display={{ sm: 'block', md: 'block', lg: 'none', xl: 'none' }}>
            <UbiButton onClick={() => setLogin(true)} style='solid' type='secondary' label={t('common.login')} css={{ width: '100%' }} />
          </Flex>
        </Flex>

        <Flex
          display={login ? 'block' : { sm: 'none', md: 'none', lg: 'block', xl: 'block' }}
          width='400px'
          maxHeight={login ? undefined : 'calc(100vh - 160px)'}
          overflowY='auto'
          backgroundColor='white'
          borderRadius='8px'
          alignSelf='center'
          ml='auto'
        >
          <Outlet />
        </Flex>
      </Flex>
    </Flex>
  )
}
